export default __webpack_public_path__ + "static/media/Tools-P13-CIFOR.d5ad5d46.jpg";